import { type FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useViewer } from "~/api/queries";
import { Avatar } from "~/foundation/components/Avatar";
import { Button } from "~/foundation/components/Button";
import { Input } from "~/foundation/components/Input";
import { Spinner } from "~/foundation/components/Spinner";
import { Text } from "~/foundation/components/Text";

export function Profile() {
  const { t } = useTranslation();
  const { data: viewer, isLoading } = useViewer();
  const [name, setName] = useState("");

  useEffect(() => {
    if (viewer) {
      setName(viewer.name);
    }
  }, [viewer]);

  if (isLoading || !viewer) {
    return <Spinner label={t("Loading")} />;
  }

  const submit = (event: FormEvent) => {
    event.preventDefault();
    // SLATE-LATER (§15): PATCH /viewer once the profile endpoint exists.
    toast.success(t("Profile saved"));
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-5">
      <div className="flex items-center gap-4">
        <Avatar name={viewer.name} src={viewer.avatarUrl} size={32} />
        <div>
          <Text variant="body">{t("Profile photo")}</Text>
          <Text variant="small">{t("Falls back to your initials.")}</Text>
        </div>
      </div>

      <Input
        label={t("Full name")}
        value={name}
        fullWidth
        onChange={(event) => setName(event.target.value)}
      />
      <Input
        label={t("Email")}
        value={viewer.email}
        fullWidth
        readOnly
        hint={t("Email is managed by your identity provider.")}
      />

      <div>
        <Button type="submit" variant="primary" disabled={name.trim() === ""}>
          {t("Save")}
        </Button>
      </div>
    </form>
  );
}
